<script>   

    export let ShowLeft = true;
    export let Height1 = 55;
    export let Height3 = 55; //70;


    document.documentElement.style.setProperty("--Height1", Height1);
    document.documentElement.style.setProperty("--Height3", Height3);
;</script>

<style>
.main-box{
    width: 100%;
    height: 91%;
    margin: 0px;
    padding: 0px;
    margin-top: 86px;
    /* background-color: red; */
    border-radius: 0px;    
    overflow: auto;
    display: flex;
    flex-direction:column;
    flex-wrap: wrap;    
}

.box1{
    height: calc((var(--Height1) * 0.25) * 1%);
    width: 100%;
    /* background-color: blue;   */
    overflow: auto;
    margin-bottom: 0px;
    padding-bottom: 0px;
    height: 100%;
}

@media screen and (max-width: 600px) {
    .main-box{
        flex-direction:row;
    }   

    .box1{
        width: 100%;
    }
}
</style>

<div class="main-box">
    <div class="box1 {ShowLeft === false ? 'fullWidth' : ''}">            
        <slot name="box1"></slot>
</div>
</div>